module Sm.UI.Components.NavBar

open System
open Fable.React
open Fable.React.Props
open MobF.React
open Browser.Navigator

open Sm.Service.Remote.Synchronizer
open Sm.Core.Date

open Sm.UI
open Sm.UI.Form
open Sm.UI.Main

[<ObserverComponent>]
let NavBar (props: {| Main: Main.Type |}) =
    let main = props.Main
    let menu = main.State.Menu

    nav [] [
        Menu.MenuView { Menu = menu }

        match main.Computed.SyncStatus with
        | HaltedSince (t, error) ->
            let syncWidget icon msg =
                span [Class "sync-status"; Title msg; Data ("error", error)] [
                    iconFor icon []
                ]

            if not navigator.onLine then
                syncWidget Offline "Changes are not synchronized because you are offline"
            elif t.HasElapsed(TimeSpan.OneMinute) then
                syncWidget Warning "Unable to synchronize"
            else
                nothing

        | _ -> nothing
    ]
